import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../../components/SeoHead';
import MainBanner from '../../../../components/MainBanner';
import ImageWithText from '../../../../components/ImageWithText';
import ImageWithTextWithCardPadding from '../../../../components/ImageWithTextWithCardPadding';

export default function CSRPartnershipsPage({
    global,
    all_csr_partners_us
}) {
    return (
        <>
            <SeoHead
                page_name={`CSR Partnerships | The global house of tech and transformation recruitment | Lorien | United States`}
                canonical_link={`csr`}
                en_gb={false}
                en_us={true}
                
            />
            <MainBanner
                global={global}
                pathPrefix={`csr_partnership_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>CSR & Partnerships</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/sub-banner-about-us.png`}
                imageALT2={`Overlay Main Banner`}
            />
            <ImageWithTextWithCardPadding
                global={global}
                pathPrefix={`csr_partnership_page.image_with_text_with_card_padding`}
                customClass={`py-5 grayGradientBg no-bg-`}
                content={
                    <>
                        <h2>Our CSR Partners</h2>
                        <p>
                            We’re determined to build a better future for everyone. In 2022 Lorien, alongside sister brands SRG and Carbon60, appointed Chris Blackburn as our Head of CSR. Chris is helping us find ways to give back to our local community and to solve key issues our world faces – such as STEM skill shortages, equal opportunities, and access to resources.

                            We’re working with a number of partners to help us achieve this, including MAMA.codes, Lucy Air Ambulance for Children and TechGirls. Find out more about these amazing businesses and charities below.</p>
                    </>
                }
                buttonLink={``}
                buttonTitle={``}
                post={all_csr_partners_us}
                transparent_card={true}
                enableContent={true}
            />
            <ImageWithText
                global={global}
                pathPrefix={`csr_partnership_page.image_with_text`}
                customClass={``}
                post={``}

            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const csr_partners_us = await Collection('csr_partners_us');

    const all_csr_partners_us = csr_partners_us.orderBy('_order').getItems();
    return {
        props: {
            global,
            all_csr_partners_us
        }
    };
}
